import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { botsAPI } from '../services/api';
import { ArrowLeft, Copy, Check, Code2, FrameIcon } from 'lucide-react';

export default function BotEmbed() {
  const { id } = useParams();
  const [embed, setEmbed] = useState(null);
  const [copied, setCopied] = useState('');

  useEffect(() => {
    botsAPI.embed(id).then(r => setEmbed(r.data)).catch(() => toast.error('Failed to load embed code'));
  }, [id]);

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    toast.success('Copied to clipboard!');
    setTimeout(() => setCopied(''), 2000);
  };

  if (!embed) return <div style={{ display:'flex',justifyContent:'center',padding:60 }}><div className="spinner"/></div>;

  return (
    <div>
      <div className="page-header" style={{ display:'flex',alignItems:'center',gap:12 }}>
        <Link to="/bots" className="btn btn-ghost btn-icon"><ArrowLeft size={18}/></Link>
        <div><h1>Embed Chatbot</h1><p>Add this chatbot to your website</p></div>
      </div>

      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))',gap:20 }}>
        <div className="card">
          <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:16 }}>
            <Code2 size={18} style={{ color:'var(--brand)' }}/>
            <h3 style={{ fontFamily:'var(--font-head)',fontSize:15,fontWeight:700 }}>Script Tag (Recommended)</h3>
          </div>
          <p style={{ fontSize:13,color:'var(--text2)',marginBottom:16,lineHeight:1.6 }}>
            Paste this before the closing <code style={{background:'var(--surface2)',padding:'1px 6px',borderRadius:4,fontSize:12}}>&lt;/body&gt;</code> tag on every page.
          </p>
          <pre className="code-block" style={{ fontSize:12,lineHeight:1.7 }}>{embed.snippet}</pre>
          <button className="btn btn-primary btn-sm" style={{ marginTop:12 }} onClick={() => copy(embed.snippet, 'script')}>
            {copied==='script' ? <><Check size={13}/> Copied!</> : <><Copy size={13}/> Copy code</>}
          </button>
        </div>

        <div className="card">
          <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:16 }}>
            <FrameIcon size={18} style={{ color:'var(--blue)' }}/>
            <h3 style={{ fontFamily:'var(--font-head)',fontSize:15,fontWeight:700 }}>iFrame Embed</h3>
          </div>
          <p style={{ fontSize:13,color:'var(--text2)',marginBottom:16,lineHeight:1.6 }}>
            Embed the chat directly in a page section instead of as a floating widget.
          </p>
          <pre className="code-block" style={{ fontSize:12,lineHeight:1.7 }}>{`<iframe\n  src="${process.env.REACT_APP_WIDGET_URL}/bot/${embed.botId}"\n  width="400"\n  height="600"\n  style="border:none;border-radius:12px"\n  title="Chat"\n></iframe>`}</pre>
          <button className="btn btn-secondary btn-sm" style={{ marginTop:12 }} onClick={() => copy(`<iframe src="${process.env.REACT_APP_WIDGET_URL}/bot/${embed.botId}" width="400" height="600" style="border:none;border-radius:12px" title="Chat"></iframe>`, 'iframe')}>
            {copied==='iframe' ? <><Check size={13}/> Copied!</> : <><Copy size={13}/> Copy iFrame</>}
          </button>
        </div>
      </div>

      <div className="card" style={{ marginTop:20 }}>
        <h3 style={{ fontFamily:'var(--font-head)',fontSize:15,fontWeight:700,marginBottom:16 }}>Bot ID</h3>
        <div style={{ display:'flex',alignItems:'center',gap:10 }}>
          <code style={{ background:'var(--bg3)',padding:'8px 14px',borderRadius:'var(--radius)',fontSize:14,color:'var(--brand)',flex:1,wordBreak:'break-all' }}>{embed.botId}</code>
          <button className="btn btn-secondary btn-sm" onClick={() => copy(embed.botId, 'id')}>
            {copied==='id' ? <Check size={13}/> : <Copy size={13}/>}
          </button>
        </div>
        <p className="form-hint" style={{ marginTop:8 }}>Use this ID with our JavaScript API for custom integrations.</p>
      </div>
    </div>
  );
}
